import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoginHero from "../../assets/heroes/login-hero.png";
import AppLogo from "../../components/AppLogo";
import ChangeLangButton from "../../components/language/ChangeLangButton";

function NotFoundPage() {
  const LocalBasePath = "page.notFound";
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <div className="min-h-screen flex">
        <div className="flex-1 flex flex-col justify-between  py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="h-5"></div>
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="text-center">
              <AppLogo />
              <h2 className="mt-6 text-4xl font-extrabold text-gray-700">
                {t(`${LocalBasePath}.unfortunately`)}
              </h2>
              <button
                onClick={() => navigate("/")}
                className="mt-4 w-full py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
              >
                {t(`${LocalBasePath}.contactTheLiaison`)}
              </button>
            </div>
          </div>
          <ChangeLangButton />
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={LoginHero}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
export default NotFoundPage;
